import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // Navbar
      "nav_home": "Home",
      "nav_about": "About",
      "nav_projects": "Projects",
      "nav_contact": "Contact",
      "change_lang": "العربية",
      "download_cv": "Download CV",

      // Hero Section
      "hello": "Hello, It's Me",
      "name": "ZIAD HAMADA",
      "job_titles": ["Front-End Developer", "Survey Engineer", "GIS Specialist"],
      "desc": "A versatile professional skilled in web development, graphic design, and geomatics engineering. Creates responsive websites, eye-catching visuals, and accurate spatial data solutions.",
      "btn_about": "More About Me",

      // About Section
      "about_text": "Hello! I am a Frontend Developer and GIS Specialist passionate about building smooth web experiences and modern designs. I love turning complex ideas into simple, maintainable code, blending technical precision with creative flair.",
      "skills_title": "My Skills", 

      // Projects General
      "view_project": "View Project",

      // Project 1: El Rawi
      "elrawi": "El Rawi Food Industries",
      "p1_desc": "A modern website for a leading food company specializing in high-quality Tahini and Halva products.",

      // Project 2: El Araby
      "elaraby": "El Araby Design",
      "p2_desc": "A creative portfolio for a graphic designer, integrating spatial data visualizations and interactive design elements.",

      // Project 3: ZED
      "zed": "ZED Clothing Brand",
      "p3_desc": "An e-commerce platform for a local Egyptian fashion brand, providing a seamless shopping experience for modern apparel.",

      // Project 4: Burullus (Graduation Project)
      "Brolos": "Burullus Lake Monitoring System",
      "p4_desc": "Advanced dashboard for environmental monitoring and spatial analysis of Lake Burullus using remote sensing techniques.",

      // Project 5: Calculator
      "calculoter": "Modern Web Calculator",
      "p5_desc": "A sleek and responsive web-based calculator built to handle daily mathematical operations with a smooth interface.",

      // Project 6: Exam System
      "Exzam": "Online Examination System",
      "p6_desc": "An interactive digital assessment platform designed to manage exams, evaluate performance, and provide instant results.",

      // Project 7: Inventory System (التعديل هنا)
      "inventory_system": "Smart Inventory Management System",
      "inventory_desc": "A comprehensive platform for tracking products, managing suppliers, and monitoring stock movements with high precision and real-time reports.",

      // Project 8: Urban
      "proj1_title": "Urban Expansion Dashboard",
      "proj1_desc": "Visualizing city growth over centuries using spatial data.",

      // Contact
      "contact_sub": "Liked my work? Let's talk!",
      "placeholder_name": "Your Name",
      "placeholder_email": "Your Email",
      "placeholder_msg": "Your Message",
      "btn_send": "Send Message",

      // Footer
      "footer_desc": "Front-End Developer & GIS Specialist focused on creating interactive web experiences and precise data visualization."
    }
  },
  ar: {
    translation: {
      // Navbar
      "nav_home": "الرئيسية",
      "nav_about": "عني",
      "nav_projects": "مشاريعي",
      "nav_contact": "تواصل معي",
      "change_lang": "English",
      "download_cv": "تحميل السيرة الذاتية",

      // Hero Section
      "hello": "أهلاً، أنا",
      "name": "زياد حمادة",
      "job_titles": ["مبرمج واجهات أمامية", "مهندس مساحة", "أخصائي GIS"],
      "desc": "متخصص متعدد المهارات في تطوير الويب، التصميم الجرافيكي، وهندسة الجيوماتكس. أقوم ببناء مواقع متجاوبة، وتصاميم بصرية جذابة، وحلول دقيقة للبيانات المكانية.",
      "btn_about": "تعرف عليّ أكثر",

      // About Section
      "about_text": "أهلاً! أنا مطور واجهات مستخدم (Frontend Developer) وأخصائي نظم معلومات جغرافية (GIS)، شغوف ببناء تجارب ويب سلسة وتصاميم عصرية. أحب تحويل الأفكار المعقدة إلى كود بسيط وقابل للصيانة، مع دمج الدقة التقنية باللمسة الإبداعية.",
      "skills_title": "مهاراتي",

      // Projects General
      "view_project": "عرض المشروع",

      // Project 1: El Rawi
      "elrawi": "الراوي للصناعات الغذائية",
      "p1_desc": "موقع إلكتروني عصري لشركة رائدة في المنتجات الغذائية (طحينة وحلاوة طحينية)، يتميز بتصميم جذاب وتجربة مستخدم سلسة.",

      // Project 2: El Araby
      "elaraby": "العربي للتصميم",
      "p2_desc": "معرض أعمال إبداعي لمصمم جرافيك، يدمج بين عرض البيانات المكانية وعناصر التصميم التفاعلية.",

      // Project 3: ZED
      "zed": "براند زيد للملابس",
      "p3_desc": "منصة تجارة إلكترونية لعلامة تجارية مصرية للملابس، توفر تجربة تسوق سلسة للأزياء العصرية مع واجهة تفاعلية.",

      // Project 4: Burullus
      "Brolos": "نظام رصد بحيرة البرلس",
      "p4_desc": "مشروع التخرج من كلية الجيوماتكس. لوحة تحكم متقدمة للرصد البيئي والتحليل المكاني لبحيرة البرلس باستخدام الاستشعار عن بعد.",

      // Project 5: Calculator
      "calculoter": "آلة حاسبة عصرية",
      "p5_desc": "آلة حاسبة متجاوبة عبر الويب، مصممة لإجراء العمليات الحسابية اليومية بواجهة مستخدم سلسة وسهلة الاستخدام.",

      // Project 6: Exam System
      "Exzam": "نظام الامتحانات الإلكتروني",
      "p6_desc": "منصة تقييم رقمية تفاعلية مصممة لإدارة الاختبارات وتقييم أداء الطلاب وتقديم النتائج فورياً.",

      // Project 7: Inventory System (التعديل هنا)
      "inventory_system": "نظام ذكي لإدارة المخزون",
      "inventory_desc": "منصة متكاملة لتتبع المنتجات، إدارة الموردين، ومراقبة حركة الصادر والوارد بدقة عالية مع تقارير تحليلية فورية.",

      // Project 8: Urban
      "proj1_title": "لوحة متابعة التوسع العمراني",
      "proj1_desc": "تصوير نمو المدن عبر القرون باستخدام البيانات المكانية.",

      // Contact
      "contact_sub": "عجبك شغلي؟ خلينا نتكلم!",
      "placeholder_name": "اسمك الكريم",
      "placeholder_email": "بريدك الإلكتروني",
      "placeholder_msg": "رسالتك",
      "btn_send": "إرسال الرسالة", 

      // Footer
      "footer_desc": "مطور واجهات أمامية وأخصائي نظم معلومات جغرافية (GIS). أسعى لابتكار تجارب رقمية تفاعلية تجمع بين دقة البيانات وجمال التصميم."
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", 
  interpolation: { escapeValue: false }
});

export default i18n;